import { LegalPage } from "@/components/LegalPage";

// Legal text. Change the wording only with the owner's sign-off, and update
// the date when you do.
export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      description="The terms that apply when you use MineOptics."
      path="/terms"
      updated="January 2024"
    >
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using MineOptics ("the Service"), you agree to be bound by these Terms of Service. If you
          disagree with any part of these terms, you may not access the Service.
        </p>
      </section>

      <section>
        <h2>2. Description of Service</h2>
        <p>
          MineOptics provides a cloud-based mining cost modeling and financial analysis platform. The Service includes
          tools for drilling and blasting cost analysis, revenue modeling, cashflow projections, and reporting
          capabilities.
        </p>
      </section>

      <section>
        <h2>3. User Accounts</h2>
        <h3>3.1 Account Creation</h3>
        <ul>
          <li>You must provide accurate and complete information</li>
          <li>You are responsible for maintaining account security</li>
          <li>You must notify us immediately of unauthorized access</li>
          <li>You are responsible for all activities under your account</li>
        </ul>
        <h3>3.2 Account Eligibility</h3>
        <p>
          You must be at least 18 years old and have the authority to enter into these Terms on behalf of yourself or
          your organization.
        </p>
      </section>

      <section>
        <h2>4. Subscription and Payment</h2>
        <h3>4.1 Subscription Plans</h3>
        <p>
          MineOptics offers various subscription plans. By subscribing, you agree to pay the fees associated with your
          selected plan.
        </p>
        <h3>4.2 Billing</h3>
        <ul>
          <li>Subscriptions are billed in advance on a monthly or annual basis</li>
          <li>All fees are non-refundable except as required by law</li>
          <li>We may change our fees with 30 days notice</li>
          <li>Failure to pay may result in service suspension or termination</li>
        </ul>
      </section>

      <section>
        <h2>5. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for any illegal purpose</li>
          <li>Violate any laws or regulations</li>
          <li>Infringe upon intellectual property rights</li>
          <li>Transmit malicious code or viruses</li>
          <li>Attempt to gain unauthorized access to the Service</li>
          <li>Interfere with or disrupt the Service</li>
          <li>Use the Service to compete with MineOptics</li>
          <li>Share your account credentials with others</li>
        </ul>
      </section>

      <section>
        <h2>6. Intellectual Property</h2>
        <h3>6.1 Our IP</h3>
        <p>
          The Service and its original content, features, and functionality are owned by MineOptics and are protected by
          international copyright, trademark, and other intellectual property laws.
        </p>
        <h3>6.2 Your Data</h3>
        <p>
          You retain all rights to your data. You grant us a license to use, store, and process your data solely to
          provide the Service.
        </p>
      </section>

      <section>
        <h2>7. Data Security and Backups</h2>
        <p>
          While we implement security measures to protect your data, you are responsible for maintaining your own
          backups. We are not liable for any data loss.
        </p>
      </section>

      <section>
        <h2>8. Service Availability</h2>
        <p>
          We strive to maintain 99.9% uptime but do not guarantee uninterrupted access. We may perform maintenance and
          updates that temporarily affect availability.
        </p>
      </section>

      <section>
        <h2>9. Termination</h2>
        <p>
          We may terminate or suspend your account immediately, without prior notice, for any breach of these Terms. Upon
          termination, your right to use the Service will immediately cease.
        </p>
      </section>

      <section>
        <h2>10. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, MineOptics shall not be liable for any indirect, incidental, special,
          consequential, or punitive damages resulting from your use of the Service.
        </p>
      </section>

      <section>
        <h2>11. Disclaimer of Warranties</h2>
        <p>
          The Service is provided "as is" and "as available" without warranties of any kind, either express or implied,
          including but not limited to warranties of merchantability, fitness for a particular purpose, or
          non-infringement.
        </p>
      </section>

      <section>
        <h2>12. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict
          of law provisions.
        </p>
      </section>

      <section>
        <h2>13. Changes to Terms</h2>
        <p>
          We reserve the right to modify these Terms at any time. We will notify users of any material changes. Your
          continued use of the Service after changes constitutes acceptance of the new Terms.
        </p>
      </section>

      <section>
        <h2>14. Contact Information</h2>
        <p>For questions about these Terms, please contact us at:</p>
        <p>
          Email: <a href="mailto:legal@mineoptics.com">legal@mineoptics.com</a>
        </p>
      </section>
    </LegalPage>
  );
}
